<!-- 竞猜规则弹窗 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="title-text">赌神榜规则</div>
        <div class="tag"><img :src="require('../assets/happy.png')" alt="" height="65"></div>
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" alt="" height="33"></div>
        <div class="rule-cont">
            <div class="rule-item">
                <div class="cont">1、</div>
                <div class="flex-cont">
                    <div class="txt">按照下注后盈利金额进行排名。</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">2、</div>
                <div class="flex-cont">
                    <div class="txt">盈利金额，是指竞猜获胜用户按照每场比赛“主胜”、“平”、“客胜”对应的赔率，累计净赚的金币。</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">3、</div>
                <div class="flex-cont">
                    <div class="txt">举例：用户在“主胜 1.5”、“平 2”、“客胜3.5”中下注100金币，竞猜胜利，净赚的金币为50。</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">4、</div>
                <div class="flex-cont">
                    <div class="txt">相同金币数量，充值较多的排名靠前。</div>
                </div>
            </div>

        </div>
        

    </div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
export default {
    name :'GamblersGoldRules',
    props:['status'],
    data(){
        return {}
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:700px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; padding:20px 25px; position: relative; border-radius: 10px; background-size: 100%;
    .title-text{font-size: 20px; line-height: 40px; color: #fff; font-weight: 600; margin-bottom: 10px;}
    .tag{position: absolute; right: 75px; top: 5px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.rule-cont{
    padding: 20px; background: #fff; border-radius: 10px; 
    .rule-item{
        display: flex; font-size: 16px; line-height: 30px; color: #353535;
        .li-ico{padding-top: 3px; margin-right: 3px;}
    }
}
@media screen and (max-width:768px) {
    .ball-cup-container{
        padding: 20px 10px;
    }
    .rule-cont{padding: 10px;}
}
</style>